


import {SV_SOJ_ORCMOCK_ADDRESS} from '../constants'
const _ = require('lodash')

let initStore = {
    loading: false,
    error: false,
    my_data_svtoc:{
        "id": "addLeft_step",
        "testlastName": "svlondonKW",
        "dateOfBirth": "6000-01-15",
        "members": [
            {
                "tid": 1,
                "dateOfBirth": "1982-01-15",
                "gender": "MALE",
                "firstName": "svkap",
                "lastName": "sval",
                "emailAddress": "svr@yahoo.com",
                "memphones": [
                    {
                        "deviceType": "MOBILE",
                        "countryCallingCode": "34",
                        "number": "480080085"
                    }
                ],
                "members": [
                    {
                        "documentType": "IDENTITY_CARD",
                        "birthPlace": "Sanfrancisco",
                        "issuanceLocation": "Sanfrancisco",
                        "issuanceDate": "2015-04-13",
                        "documentNumber": "00000069",
                        "expiryDate": "2025-04-13",
                        "issuanceCountry": "US",
                        "validityCountry": "US",
                        "nationality": "US",
                        "holder": "Y"
                    }
                ],
                "id": "addLeft_STEP",
                "gene": "addLeft_STEP",
                "clubName": "Soccer"
            },
            {
                "tid": 2,
                "dateOfBirth": "1982-01-15",
                "gender": "MALE",
                "firstName": "Seteve",
                "lastName": "Borrow",
                "emailAddress": "steve@yahoo.com",
                "memphones": [
                    {
                        "deviceType": "MOBILE",
                        "countryCallingCode": "1",
                        "number": "480080081"
                    }
                ],
                "members": [
                    {
                        "documentType": "IDENTITY_CARD",
                        "birthPlace": "Sanfrancisco",
                        "issuanceLocation": "Sanfrancisco",
                        "issuanceDate": "2015-04-13",
                        "documentNumber": "00000069",
                        "expiryDate": "2025-04-13",
                        "issuanceCountry": "US",
                        "validityCountry": "US",
                        "nationality": "US",
                        "holder": "Y"
                    }
                ],
                "id": "addLeft_STEP1",
                "gene": "addLeft_STEP1",
                "clubName": "SVCriuseBALL"
            }
        ],
           "gender": "MALE"
    },
    /*sva*/
    errob :{
        "timestamp": "2015-08-23T02:27:18.038+0000",
        "status": 500,
        "error": "Default Error",
        "message": "500 null",
        "path": "/kk/svaddressDetailPost"
    },
    crudsuccessob :{
        "timestamp": "2015-08-23T02:27:18.038+0000",
        "status": 200,
        "error": "Default Error",
        "message": "500 null",
        "path": "/kk/svaddressDetailPost"
    },
    /*svae */
    my_data: [],
    loadingFLYRESERVATION:false,
    errorFLYRESERVATION:false,
    my_data_traveller:{
        "id": "addLeft_step",
        "dateOfBirth": "1950-09-19",
        "gender": "FEMALE",
        "gene": "addLeft_step",
        "dcountry": "China",
        "privateparking":false,
        "rentcar":false,
        "bookTaxi":false,
        "needFlight":false,
        "arrivalTimeZone":"tz_pst",
        "fname": "John",
        "lname": "Glen",
        "email": "john123@yahoo.com",
        "address": "Glen",
        "city": "Glen",
        "state": "ca",
        "zip": "12110",
        "country": "Glen",
        "isdcode": "+1",
        "phone": "Glen",
        "bookingAgentType": "self",
        "traveType": "Personal",
        "specialRequests": "Wheel chair and Senior Citizen",
        "gname": "Glen",
        "gemail": "Glen@yahoo.com",
        "card": "1234-1234--1234--1234",
        "cvv": "Glen",
        "mmexp": "04",
        "yyyyexp": "2028"
    },
    custProfile: {
        "customerId": 6,
        "addressId":-1
    },
    my_data_geo:{
        "countryTypes": [
            {
                "name": "United STates America",
                "a2": "US",
                "a3": "USA",
                "value": "USA",
                "isonum": "840"
            },
            {
                "name": "Canada",
                "isdcode": "01",
                "a2": "CA",
                "a3": "CAN",
                "value": "CAN",
                "isonum": "124"
            }
        ],
        "stateTypes": [
            {
                "name": "California",
                "value": "CA",
                "a2": "CA"
            },
            {
                "name": "New York",
                "value": "NY",
                "a2": "NY"
            },
            {
                "name": "Texas",
                "value": "TX",
                "a2": "TX"
            }
        ],
        "isdcodeTypes": [
            {
                "name": "United States Of America(+1)",
                "value": "1"
            },
            {
                "name": "Australia(+61)",
                "value": "61"
            },
            {
                "name": "Spain(+34)",
                "value": "34"
            }
        ],
        "genderTypes": [
            {
                "name": "CL_MALE",
                "value": "MALE"
            },
            {
                "name": "CL_FEMALE",
                "value": "FEMALE"
            }
        ]
    },
    my_data_dtoken:{
        "email": "suelb22@yahoo.com",
        "subject": "Reservation Details",
        "customerId": "-131",
        "status": "OK",
        "digitalCode": "111111"
    },
    my_data_card:{
        "id": "-4",
        "cardId": "-4",
        
        "name": "",
        "zip": "",
        "country": "usa",
        "isdcode": "",
        "phone": "",

        "card": "7777-1234--1234--1234",
        "cvv": "777",
        "mmexp": "07",
        "yyyyexp": "77",
        "cardZipcode" :"95020",
        "cardName" :"james watt",
        "cardCountrya3" :"usa", 
        "otherDetails" :"Default facility",
        "specialRequests": "Default chair and Senior Citizen",
        "privateparking":false,
            "rentcar":false,
            "bookTaxi":false,
            "needFlight":false,
            "arrivalTimeZone":"tz_pst"
      
        
    
      },
      my_data_svtpi : [{
        "tid":1,
        "dateOfBirth": "1982-01-15",
        "gender": "MALE",
        "firstName": "Svbsv",
        "lastName": "Infinity",
        "emailAddress": "svr@yahoo.com",
        "memphones":[{       
            "deviceType": "MOBILE",
            "countryCallingCode": "34",
            "number": "480080085"
        }],
        "members": [
          {
            "documentType": "IDENTITY_CARD",
            "birthPlace": "Sanfrancisco",
            "issuanceLocation": "Sanfrancisco",
            "issuanceDate": "2015-04-13",
            "documentNumber": "00000069",
            "expiryDate": "2025-04-13",
            "issuanceCountry": "US",
            "validityCountry": "US",
            "nationality": "US",
            "holder": "Y"
          }
        ],
        id:'addLeft_STEP',
        gene:'addLeft_STEP',
        "clubName": "Soccer"
      
      
      }],
      my_data_svdoc:{
        "tid":1,
        "dateOfBirth": "1982-01-15",
        "gender": "MALE",
        "firstName": "Svbsv",
        "lastName": "Infinity",
        "emailAddress": "svr@yahoo.com",
        "memphones":[{       
            "deviceType": "MOBILE",
            "countryCallingCode": "34",
            "number": "480080085"
        }],
        "members": [
          {
            "documentType": "IDENTITY_CARD",
            "birthPlace": "Madrid",
            "issuanceLocation": "Madrid",
            "issuanceDate": "2015-04-13",
            "documentNumber": "00000069",
            "expiryDate": "2025-04-13",
            "issuanceCountry": "ES",
            "validityCountry": "ES",
            "nationality": "ES",
            "holder": "Y"
          }
        ],
        id:'addLeft_STEP',
        gene:'addLeft_STEP',
        "clubName": "Soccer"
      
      
      },

    my_data_flyaddress: {
        "id": -6,
        "addressId": 36,
        "customerId": 36,
        "name": "alen beta",
        "fname": "alen",
        "lname": "beta",
        "phone": "3621231234",
        "email": "alen36default@br.com",
        "login": "alenb",
        "password": null,
        "otherDetails": "need pickup",
        "city": "san jose default",
        "state": "ca",
        "country": "usa",
        "address": null,
        "zip": "99999",
        "zipcode": "99999",
        "isdcode": "1",
        "addressType": "B",
        "createdDate": null,
        "modifiedDate": null,
        "createdBy": null,
        "modifiedBy": null
    },
    my_data_flyreview:{
        "offer":{
            "type": "flight-offer",
            "id": "3",
            "source": "GDS",
            "instantTicketingRequired": false,
            "nonHomogeneous": false,
            "oneWay": false,
            "isUpsellOffer": false,
            "lastTicketingDate": "2024-10-30",
            "lastTicketingDateTime": "2024-10-30",
            "numberOfBookableSeats": 7,
            "itineraries": [
               
            ],
            "price": {
                "currency": "USD",
                "total": "256.24",
                "base": "210.24",
                "fees": [
                    {
                        "amount": "0.00",
                        "type": "SUPPLIER"
                    },
                    {
                        "amount": "0.00",
                        "type": "TICKETING"
                    }
                ],
                "grandTotal": "256.24"
            },
            "pricingOptions": {
                "fareType": [
                    "PUBLISHED"
                ],
                "includedCheckedBagsOnly": false
            },
            "validatingAirlineCodes": [
                "AS"
            ],
            "travelerPricings": [
                {
                    "travelerId": "1",
                    "fareOption": "STANDARD",
                    "travelerType": "ADULT",
                    "price": {
                        "currency": "USD",
                        "total": "128.12",
                        "base": "105.12"
                    },
                    "fareDetailsBySegment": [
                        {
                            "segmentId": "3",
                            "cabin": "ECONOMY",
                            "fareBasis": "OH2OXVBN",
                            "brandedFare": "SV",
                            "brandedFareLabel": "SAVER",
                            "class": "X",
                            "includedCheckedBags": {
                                "quantity": 0
                            },
                            "amenities": [
                                {
                                    "description": "STANDARD PIECE MAX 50LB 62LI",
                                    "isChargeable": true,
                                    "amenityType": "BAGGAGE",
                                    "amenityProvider": {
                                        "name": "BrandedFare"
                                    }
                                },
                                {
                                    "description": "MEAL 1",
                                    "isChargeable": true,
                                    "amenityType": "MEAL",
                                    "amenityProvider": {
                                        "name": "BrandedFare"
                                    }
                                },
                                {
                                    "description": "110V AC POWER",
                                    "isChargeable": false,
                                    "amenityType": "ENTERTAINMENT",
                                    "amenityProvider": {
                                        "name": "BrandedFare"
                                    }
                                },
                                {
                                    "description": "USB POWER",
                                    "isChargeable": false,
                                    "amenityType": "ENTERTAINMENT",
                                    "amenityProvider": {
                                        "name": "BrandedFare"
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    "travelerId": "2",
                    "fareOption": "STANDARD",
                    "travelerType": "ADULT",
                    "price": {
                        "currency": "USD",
                        "total": "128.12",
                        "base": "105.12"
                    },
                    "fareDetailsBySegment": [
                        {
                            "segmentId": "3",
                            "cabin": "ECONOMY",
                            "fareBasis": "OH2OXVBN",
                            "brandedFare": "SV",
                            "brandedFareLabel": "SAVER",
                            "class": "X",
                            "includedCheckedBags": {
                                "quantity": 0
                            },
                            "amenities": [
                                {
                                    "description": "STANDARD PIECE MAX 50LB 62LI",
                                    "isChargeable": true,
                                    "amenityType": "BAGGAGE",
                                    "amenityProvider": {
                                        "name": "BrandedFare"
                                    }
                                },
                                {
                                    "description": "MEAL 1",
                                    "isChargeable": true,
                                    "amenityType": "MEAL",
                                    "amenityProvider": {
                                        "name": "BrandedFare"
                                    }
                                },
                                {
                                    "description": "110V AC POWER",
                                    "isChargeable": false,
                                    "amenityType": "ENTERTAINMENT",
                                    "amenityProvider": {
                                        "name": "BrandedFare"
                                    }
                                },
                                {
                                    "description": "USB POWER",
                                    "isChargeable": false,
                                    "amenityType": "ENTERTAINMENT",
                                    "amenityProvider": {
                                        "name": "BrandedFare"
                                    }
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "Request": {
            "checkin": "OK",
            "stay": "6",
            "stayInit": "nights",
            "checkout": "UU12345",
            "checkinTime": "Sat, Sept 9, 3027",
            "checkinTimePrefix": "From 3:00 PM",
            "checkoutTimePrefix": "Until 11:00 AM",
            "checkoutTime": "Sat, Sept 16, 3027"
        },
        "spaceDet": {
        
            "space_details": "Queen Room with Two Queen Beds",
            "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
            "cancellation": "Free cancellation before December 9, 2024 ",
            "guests": "2 adults ",
            "cleaniness_score" : "7.7",
            "non_smoking":true,
    
            "space_amenity_name": [
                "300 feet elevator",
                "air conditioning",
                "private bathroom"
            ]
           
           
        },
        "booking": {
            "airport_id": 30009,
            "origin_airport_code": 1,
            "origincity": "homer",
            "origin_airport_city": "homer",
            "origin_airport_country": "usa",
            "origin_airport_timezone": "america/new_york",
            "port_code_iata": 30009,
            "airlines_db_id": 146,
            "origin_airport_iata": "09a",
            "dst_airport_code": "adq",
            "airlines_vessel": "cr9",
            "airlines_name_iata": "2o",
            "airlines_code_iata": 4,
            "flight_space_id": 13,
            "flight_departure": "10:30",
            "flight_departure_time": "10:30",
            "flight_arrival": "04:30",
            "flight_arrival_time": "04:30",
            "flight_airline_num_stops": 1,
            "flight_arrival_daytime": "pm",
            "flight_departure_daytime": "am",
            "startdate": "2023-11-24",
            "enddate": "2026-12-01",
            "airlines_name": "air salone",
            "org_aiport_csc_addr": "homer,alaska,usa",
            "flight_time_hhmm": "6hr 29min",
            "flight_time": 209,
            "flight_operated_by": "4009 operated by envoy airlines",
            "flight_operator_owned": "y",
            "origin_airport_state": "alaska",
            "flight_departure_time_tzest": "2025-10-25t10:30:00-0400",
            "flight_departure_date": "2025-10-25",
            "flight_arrival_date": "2025-10-26",
            "flight_arrival_time_tzest": "2025-10-26t16:30:00-0400",
            "flight_space_key": "1@4@1@adq"
        },
        "price": {
            "total": "$923",
            "base": "$700",
            "currency": "USD",
            "depositValue":"$200.26",
            "depositName":"Damage Deposit (Fully refundable)",
            
            "tax": {
               
                "taxTotal": "$102.34",
                "maintax": "$49.08",
                "citytax": "$53.26",
    
                "taxPercent": "6",
                "citytaxPercent": "6.5"
            }
        },
        "id": "addLeft_step",
        "gene": "addLeft_step",
        "dcountry": "China",
        "privateparking":false,
        "rentcar":false,
        "bookTaxi":false,
        "needFlight":false,
        "arrivalTimeZone":"tz_pst",
        "fname": "John",
        "lname": "Glen",
        "email": "john123@yahoo.com",
        "address": "Glen",
        "city": "Glen",
        "state": "ca",
        "zip": "12110",
        //svn19 ods start
        "dateOfBirth":"1992-01-16",
        "gender":"MALE",
        //svn19 ods end
        "country": "us",
        "isdcode": "+1",
        "phone": "Glen",
        "bookingAgentType": "self",
        "traveType": "Personal",
        "specialRequests": "Wheel chair and Senior Citizen",
        "gname": "Glen",
        "gemail": "Glen@yahoo.com",
        "card": "1234-1234--1234--1234",
        "cvv": "Glen",
        "mmexp": "04",
        "yyyyexp": "2028"
    },
    my_data_fly_price_confirmation:{

        "status":"OK",
        "confirmationNumber":"UU12345",
        "chekinDate":"Jan 3027"
    },
    svr_soj_detail_images_ob:{
        "images":[`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj2.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj3.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj4.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj5.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj6.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj7.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj8.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj9.jpg`],
        "gallery":[`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj2.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj3.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj4.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj5.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj6.jpg` ],
        "arcade":[`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj2.jpg`],
        "face":[`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`]
    
    },
    
    sojourns:[]
    
}

export default (state = initStore, action) => {
    console.log(action)
    let januState, svns
    switch (action.type) {
        case "book/LIST_SOJOURNS":

     console.log('tasks LIST_SOJOURNS reducer')
     
    
      console.log(svns)
      if(Array.isArray(action.sojourns) && (action.sojourns.length >0)){
       
        state.sojourns =_.clone(action.sojourns)
      }
     svns = Object.assign({}, state, {sojourns:action.sojourns})
      console.log('sv reduce --for LIST_TASKS')
      console.log(svns)

      return svns
        case 'GET_FLY_PRICEANDTAX_SUCCESS':
            console.log("reduce %%%%%%%%GET_FLY_PRICEANDTAX_SUCCESS  success*****************");
            console.log(action.payload.my_data_fly_price_confirmation);
            // let januState = {...state, loading: false, my_data: action.payload.my_data}
            /*sva
            
            januState = {...state, loadingFLYRESERVATION: false, my_data_fly_price_confirmation: action.payload.my_data_fly_price_confirmation}
            */
            januState = {...state, loadingFLYRESERVATION: false,errorFLYRESERVATION: true, errob:null,crudsuccessob: action.payload.crudsuccessob, my_data_fly_price_confirmation: action.payload.my_data_fly_price_confirmation}
            
            return januState

        case 'GET_FLY_PRICEANDTAX_BEGIN':
            console.log("loading")
            return {...state, loadingFLYRESERVATION: true}
        case 'GET_FLY_PRICEANDTAX_ERROR':
            console.log("error")
            return {...state, errorFLYRESERVATION: true, errob:action.payload.errob,crudsuccessob:null}

        /*sva */
        case "RESET_FLY_PRICEANDTAX_INIT":
            let  my_data_fly_price_confirmation_init = {
                "id":-11,
                "status":"FAILED",
                "confirmationNumber":"",
                "chekinDate":""
            }
             console.log("reduce %%%%%%%%RESET_SAVESTOREDCARD_INIT  success*****************");
                januState = {...state, errorFLYRESERVATION:false, loadingFLYRESERVATION:false, crudsuccessob:null, my_data_fly_price_confirmation:my_data_fly_price_confirmation_init}
                return januState
        /*svae */
        
        /*SVF5 START*/
        case 'GET_FLYREVIEW_MAILUSER_SV_SUCCESS':
            console.log("reduce %%%%%%%%GET_FLYREVIEW_SUCCESS  success*****************");
            console.log(action.payload.my_data_flyreview);
            // let januState = {...state, loading: false, my_data: action.payload.my_data}
            //svn4y25 start
            januState = {...state }
            //januState = {...state, loadingFLYRESERVATION: false, my_data_dtoken:action.payload.my_data_dtoken}
             //svn4y25 end
            return januState

        /*SVF5 END*/
        case 'GET_FLYREVIEW_SUCCESS':
            console.log("reduce %%%%%%%%GET_FLYREVIEW_SUCCESS  success*****************");
            console.log(action.payload.my_data_flyreview);
            // let januState = {...state, loading: false, my_data: action.payload.my_data}
            //januState = {...state, loadingFLYRESERVATION: false, my_data_geo:action.payload.my_data_geo, my_data_flyreview: action.payload.my_data_flyreview}
            //fixnyy25 Bug if 1 offer is error . we get error all times even offer is tehre
            januState = {...state, loadingFLYRESERVATION: false, errorFLYRESERVATION: false, my_data_geo:action.payload.my_data_geo, my_data_flyreview: action.payload.my_data_flyreview}
            return januState
        case 'FLYMYRESERVATIONS_PRIMARY_ADDRESS':
                console.log("reduce OCT6 %%%%%%%%FLYMYRESERVATIONS_PRIMARY_ADDRESS  success*****************");
                console.log(action.payload.my_data_flyaddress);
                // let januState = {...state, loading: false, my_data: action.payload.my_data}
                januState = {...state,  my_data_flyaddress: action.payload.my_data_flyaddress}
                return januState
        case 'FLYMYRESERVATIONS_PRIMARY_SVTOC':
                console.log("Nov8 Gort action flyLoadsvtocData reduce Nov3 %%%%%%%%FLYMYRESERVATIONS_PRIMARY_SVDOC  success*****************");
                console.log(action.payload.my_data_svtoc);
                    // let januState = {...state, loading: false, my_data: action.payload.my_data}
                januState = {...state,  my_data_svtoc: action.payload.my_data_svtoc}
                return januState
        case 'FLYMYRESERVATIONS_PRIMARY_SVDOC':
                    console.log("Nov3 Gort action flyLoadsvdocData reduce Nov3 %%%%%%%%FLYMYRESERVATIONS_PRIMARY_SVDOC  success*****************");
                    console.log(action.payload.my_data_svdoc);
                    // let januState = {...state, loading: false, my_data: action.payload.my_data}
                    januState = {...state,  my_data_svdoc: action.payload.my_data_svdoc}
                    return januState
        /*
        case 'FLYMYRESERVATIONS_PRIMARY_SVTPI':
                    console.log("Nov6*** Gort action flyLoadsvtpiData reduce Nov3 %%%%%%%%FLYMYRESERVATIONS_PRIMARY_SVDOC  success*****************");
                    console.log(action.payload.my_data_svtpi);
                        // let januState = {...state, loading: false, my_data: action.payload.my_data}
                    januState = {...state,  my_data_svtpi: action.payload.my_data_svtpi}
                    return januState
        */
        case 'GET_FLYREVIEW_MYRESERVATION_SV_SUCCESS':
                console.log("reduce %%%%%%%%GET_FLYREVIEW_MYRESERVATION_SV_SUCCESS  success*****************");
                console.log(action.payload);

                // let januState = {...state, loading: false, my_data: action.payload.my_data}
                januState = {...state, errob:null,crudsuccessob:null,loadingFLYRESERVATION: false,my_data_geo:action.payload.my_data_geo,my_data_card:action.payload.my_data_card, my_data_flyaddress: action.payload.my_data_flyaddress,custProfile:action.payload.custProfile, my_data_flyreview: action.payload.my_data_flyreview}
                return januState
        case 'GET_FLYREVIEW_BEGIN':
                console.log("loading")
                return {...state, loadingFLYRESERVATION: true}
        //GET_OFFERREVIEW_ERROR
        case 'GET_OFFERREVIEW_ERROR':
            console.log("error")
            return {...state, errorFLYRESERVATION: true, errob:action.payload.errob }
        case 'GET_FLYREVIEW_ERROR':
                console.log("error")
                return {...state, errorFLYRESERVATION: true}
        case 'SAVETRAVELLER_FLYREVIEW_SUCCESS':
                    console.log("reduce %%%%%%%%SAVETRAVELLER_FLYREVIEW_SUCCESS   success*****************");
                    console.log(action.payload.my_data_traveller);
                    // let januState = {...state, loading: false, my_data: action.payload.my_data}
                    januState = {...state,  my_data_traveller: action.payload.my_data_traveller}
                    return januState
        case 'SAVETOCUMENT_FLYREVIEW_SUCCESS':
                    console.log("reduce %%%%%%%% NOV-11****SAVETOCUMENT_FLYREVIEW_SUCCESS   success*****************");
                    console.log(action.payload.my_data_svtoc);
                        // let januState = {...state, loading: false, my_data: action.payload.my_data}
                    januState = {...state,  my_data_svtoc: action.payload.my_data_svtoc}
                    return januState
        case 'SAVEDOCUMENT_FLYREVIEW_SUCCESS':
                    console.log("reduce %%%%%%%% NOV-5****8SAVEDOCUMENT_FLYREVIEW_SUCCESS   success*****************");
                    console.log(action.payload.my_data_svdoc);
                    // let januState = {...state, loading: false, my_data: action.payload.my_data}
                    januState = {...state,  my_data_svdoc: action.payload.my_data_svdoc}
                    return januState
        
        default:
            return state
    }
}